export const aboutUsTextContent = {
  headingText: "About Us",
  paraText: "At GammaSlots, we pair your vision with strategic expertise to deliver comprehensive and compelling slot games. From initial planning to final deployment, our approach combines industry leading tech with years of experience to meet the requirements of businesses of all sizes.",
  imageSrc: "/assets/stock-img/about_us_img.webp",
  content: [
    {
      listContent: [
        { listText: "13+ Years of Delivering Excellence" },
        { listText: "500+ Developers" },
        { listText: "100+ Games Developed" },
        { listText: "50+ Businesses Transformed" },
        { listText: "700+ Payment Methods" },
        { listText: "64+ Brands Made" },
        { listText: "200+ Projects" },
        { listText: "25+ Slot Themes & Styles" },
        { listText: "Served in 45+ Countries" },
      ],
    },
  ],
};
